exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".m-carousel[data-v-008e3634]{padding-top:86px}", ""]);

// exports
